import { render } from "./userAddModal.vue?vue&type=template&id=30e045b0&ts=true"
import script from "./userAddModal.vue?vue&type=script&lang=ts"
export * from "./userAddModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__